<template>
  <div
    :class="{
      FlipButton: true,
      nbutton: true,
      hidden:
        $store.state.ui.mode === 'no-map' ||
        $store.state.ui.mode === 'no-years' ||
        $store.state.ui.mode === 'year-highlight',
      highlighted: $store.state.ui.mode === 'highlight-flip',
      disabled: $route.name === 'narrative'
    }"
    @click="$store.dispatch('flip')"
  >
    <div>Flip</div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
    >
      <path
        d="M3.439 3.201H.333V.096c0-.038.023-.072.058-.087.036-.015.076-.007.103.02l1.213 1.213C2.755.322 4.139-.118 5.525.027 6.912.173 8.175.891 9.01 2.01c.833 1.117 1.162 2.532.906 3.903h-.907c.258-1.13.027-2.316-.635-3.266-.663-.95-1.697-1.575-2.846-1.723-1.15-.147-2.307.198-3.188.95L3.506 3.04c.027.027.035.068.02.103-.015.035-.049.058-.087.058zM4.999 10c1.213 0 2.383-.44 3.293-1.242l1.214 1.214c.026.027.067.035.102.02.036-.014.059-.048.059-.087V6.8H6.56c-.038 0-.072.023-.087.059-.015.035-.007.075.02.102l1.167 1.167c-.881.752-2.039 1.096-3.187.949-1.15-.148-2.183-.773-2.846-1.723C.965 6.404.734 5.22.992 4.09H.085c-.273 1.46.12 2.966 1.07 4.109C2.105 9.341 3.514 10.001 5 10z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "FlipButton"
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.FlipButton {
  position: absolute;
  bottom: 15px;
  right: 10px;
  z-index: 50;
  pointer-events: all;

  &.disabled {
    cursor: default;
  }

  &.highlighted {
    background-color: $light-gold;
    color: $copper;
  }

  &.hidden {
    display: none;
  }

  svg {
    padding-left: 0.5em;
    height: 19px;
    width: 19px;
  }
}
</style>
